<template>
	<div class="resourcesBox">
		<div class="top-operation">
            <el-button type="primary" @click="addResources">新增组件</el-button>
        </div>
        <el-form class="vericicationSearch" :model="resourcesSearch" ref="form" :inline="true">
            <el-form-item label="显示/隐藏：">
                <el-select v-model="resourcesSearch.status" style="width: 170px" clearable @change="handlePageChange(1)">
                    <el-option v-for="(item, index) in showData" :key="index" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-input v-model="resourcesSearch.name" placeholder="请输入组件名称搜索" @keyup.enter.native="handlePageChange(1)"></el-input>
            </el-form-item>
        </el-form>
        <el-table :data="resourcesList" border style="width: 100%">
            <el-table-column label="组件id" prop="id" align="center" width="100" />
            <el-table-column label="组件名称" prop="name" align="center" width="300" />
            <el-table-column label="组件位置" align="center" width="200">
                <template>
                    <span>发现首页</span>
                </template>
            </el-table-column>
            <el-table-column label="组件样式" align="center" width="200">
                <template slot-scope="scope">
                    <span>{{styleData[scope.row.style]}}</span>
                </template>
            </el-table-column>
			<el-table-column label="显示/隐藏" align="center">
                <template slot-scope="scope">
                    <el-switch v-model="scope.row.status" active-color="#409EFF" :active-value="1" :inactive-value="0" inactive-color="#ddd" @change="changeIsHidden(scope.row.id, scope.row.status)"></el-switch>
                </template>
            </el-table-column>
			<el-table-column label="排序权重" align="center" width="200">
                <template slot-scope="scope">
                    <i v-if="WeightIndex != scope.$index" class="el-icon-edit weightEditBtn" @click="WeightIndex = scope.$index">{{ scope.row.sort }}</i>
                    <el-input v-if="WeightIndex == scope.$index" v-model="scope.row.sort" maxlength="4" placeholder="请输入排序权重" style="width:150px">
                        <template slot="append">
                            <el-button  @click="saveWeight(scope.row.id, scope.row.sort)">保存</el-button>
                        </template>
                    </el-input>
                </template>
            </el-table-column>
            <el-table-column label="更新时间" align="center" width="200">
                <template slot-scope="scope">
					<p>{{scope.row.updatedAt | formatDateNew}}</p>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" fixed="right" width="200">
				<template slot-scope="scope">
					<el-button size="mini" @click="editRow(scope.row.id)">编辑</el-button>
					<el-button size="mini" type="danger" @click="deleteRow(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <edit ref="edit" v-if="editState" @close="resetForm" @success="editSuccess"></edit>
        <table-pagination :pageTotal="tableTotal" @handlePageChange="handlePageChange" />
	</div>
</template>

<script>
import edit from './edit'
import resourcesService from '@/services/operate/resources'
export default {
	components: { edit },
	data() {
		return {
            WeightIndex: null,
			resourcesSearch: {
                status: 1,
                name: ''
            },
			resourcesList: [],
			tableTotal: 0,
            page: {
                pageNumber: 1,
                pageSize: 20
            },
			editState: false,
			showData: [{
                label: "显示",
                value: 1
            }, {
                label: "隐藏",
                value: 0
            }],
            styleData: ['', '一行一', '二列三', '一行三']
		}
	},
	created() {
		this.getList()
	},
	methods: {
		getList() {
			resourcesService.resourcesList({ ...this.page, ...this.resourcesSearch }).then(res => {
                if(res.code == 0) {
                    this.resourcesList = res.result.data;
                    this.tableTotal = res.result.total
                } else {
                    this.$message.error(res.result);
                }
            })
		},
		editRow(id) {
			resourcesService.getResources(id).then(res => {
                this.editState = true;
                this.$nextTick(() => {
                    this.$refs.edit.editHanle(res.result)
                })
            })
		},
		deleteRow(id) {
			this.$confirm('确定要删除', {
                type: 'warning'
            }).then(async () => {
                const { code, message } = await resourcesService.deleteResources(id);
                if (Object.is(code, 0)) {
                    this.$message.success(message);
                    this.getList();
                } else {
                    this.$message.error(message);
                }
            }).catch(e => {
                console.log(e);
            })
		},
		handlePageChange(val) {
			this.page.pageNumber = val;
            this.getList()
		},
		resetForm() {
            this.editState = false;
        },
        editSuccess() {
            this.editState = false;
            this.handlePageChange(1)
        },
		addResources() {
            this.editState = true;
            this.$nextTick(() => {
                this.$refs.edit.addHanle()
            })
        },
        changeIsHidden(id, s) {
            resourcesService.resourcesChangeShow(id, { status: s }).then(() => {
                this.$message.success('修改成功')
                this.getList()
            })
        },
        saveWeight(i, w) {
            resourcesService.resourcesChangeSort(i, { sort: Number(w) }).then(() => {
                this.$message.success('编辑成功')
                this.WeightIndex = -1
                this.getList()
            });
        },
	}
}
</script>

<style lang="scss" scoped>

</style>
